const generateRateTable = (content) => {
  let bodyFromCapitalPage = document.createElement("div");
  bodyFromCapitalPage.innerHTML = content;
  const tablesFromCapitalPage =
    bodyFromCapitalPage.getElementsByTagName("table");

  if (tablesFromCapitalPage && tablesFromCapitalPage.length > 0) {
    return [
      <div
        key="rate_table"
        style={{ margin: "30px auto" }}
        dangerouslySetInnerHTML={{
          __html: tablesFromCapitalPage[0].outerHTML,
        }}
      />,
    ];
  } else {
    return [];
  }
};

export default generateRateTable;
